import { createContext, useContext } from 'react';
import { ExtractPropsFromDefinitionVersion } from '@atlassiansox/bxp-definition-sdk';
import type definition from '../../definition';
export type ModulePropsV0 = ExtractPropsFromDefinitionVersion<
  typeof definition,
  0
>;
export const ModulePropsContext = createContext<ModulePropsV0 | null>(null);
export const useModuleProps = (): ModulePropsV0 => {
  const moduleProps = useContext(ModulePropsContext);
  if (moduleProps === null) {
    throw new Error('ModulePropsContext is null');
  }
  return moduleProps;
};
